import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=17f76662&scoped=true&"
import script from "./Stars.vue?vue&type=script&lang=ts&"
export * from "./Stars.vue?vue&type=script&lang=ts&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=17f76662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f76662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
